import { fetchQuery, graphql, type Environment } from 'react-relay';

import type { FomoCollaborator } from '../types';

import type { fetchUserByAaidQuery } from './__generated__/fetchUserByAaidQuery.graphql';

/**
 * Resolve a single Atlassian Account ID (AAID) to a `FomoCollaborator`
 * by calling the AGG GraphQL `user(accountId)` field via Relay.
 *
 * Returns `null` if the user can't be resolved (network error, deactivated
 * user, missing fields, etc.). The shared Relay store means repeat lookups
 * for the same AAID are served from cache.
 */
export async function fetchUserByAaid(
	environment: Environment,
	aaid: string,
): Promise<FomoCollaborator | null> {
	try {
		const data = await fetchQuery<fetchUserByAaidQuery>(
			environment,
			graphql`
				query fetchUserByAaidQuery($accountId: ID!) {
					user(accountId: $accountId) {
						name
						picture
					}
				}
			`,
			{ accountId: aaid },
		).toPromise();

		if (!data?.user) {
			return null;
		}

		return {
			accountId: aaid,
			displayName: data.user.name ?? null,
			avatarUrl: data.user.picture ?? null,
		};
	} catch {
		return null;
	}
}
